// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1NSMG","loaderOuter":"PageOverlayLoader_loaderOuter__20BRj"};